module.exports = __webpack_public_path__ + "static/media/man_han_mul_per.6d6bd09c.png";